export default "__VITE_PUBLIC_ASSET__c284334b__"